// src/redux/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpClientXml from "../../utils/HttpClientXml";

// Async login action
export const loginUser = createAsyncThunk("auth/loginUser", async (data) => {
  return await HttpClientXml.post("login", data);
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: false,
    loading: false,
    error: null,
  },
  reducers: {
    checkLogin: (state) => {
      if (localStorage.getItem("Auth")) {
        state.token = true;
      } else {
        state.token = false;
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = false;
      localStorage.removeItem("Auth");
    },
    persistData: (state) => {
      if (
        localStorage.getItem("Auth") &&
        localStorage?.getItem("loggedInUserDetails")
      ) {
        state.token = true;
        state.user = JSON.parse(localStorage?.getItem("loggedInUserDetails"));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload?.data;
        localStorage?.setItem(
          "loggedInUserDetails",
          JSON.stringify(action.payload?.data),
        );
        if (action.payload?.status) {
          state.token = true;
          state.error = null;
          localStorage.setItem("Auth", action.payload?.data?.token);
        } else {
          state.error = action.payload.message;
          state.token = false;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, checkLogin, persistData } = authSlice.actions;
export default authSlice.reducer;
